import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { fetchLessonModules } from "../../api/lesson_modules/teachers";
import { fetchLessons } from "../../api/lessons/teachers";
import { fetchCourse } from "../../api/courses/teachers";

import { Button } from "../../components/Shared/Button"

import placeholderImage from "../../images/placeholder.png";

import "./index.css";

function BackIcon() {
  return (
    <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.7072 13.7929C9.09772 14.1834 9.09772 14.8166 8.7072 15.2071C8.31668 15.5976 7.68351 15.5976 7.29299 15.2071L1.50009 9.41421C0.719046 8.63317 0.719044 7.36684 1.50009 6.58579L7.29299 0.792894C7.68351 0.402369 8.31668 0.402369 8.7072 0.792894C9.09772 1.18342 9.09772 1.81658 8.7072 2.20711L3.91431 7H18.0001C18.5524 7 19.0001 7.44772 19.0001 8C19.0001 8.55229 18.5524 9 18.0001 9H3.91431L8.7072 13.7929Z" fill="#131313"/>
    </svg>
  )
}

function TeacherReaderItem(props) {
  const { path, text, active } = props;
  const navigate = useNavigate();
  
  function onClick() {
    navigate(path);
  }

  function getClassName() {
    if (active)
      return "TeacherReaderSidebarItem TeacherReaderSidebarItemActive"
    return "TeacherReaderSidebarItem";
  }

  return (
    <div className="TeacherReaderSidebarItemContainer">
      <div className={getClassName()} onClick={onClick}>
        <div className="TeacherReaderSidebarItemText">
          {text}
        </div>
      </div>
    </div>
  )
}

function TeacherReaderItems({ items = [] }) {
  return (
    <div className="TeacherReaderSidebarItems">
      {items.map((_props) => <TeacherReaderItem {..._props} />)}
    </div>
  )
}

function TeacherReaderSidebar() {
  const navigate = useNavigate();
  const { lessonId } = useParams();
  const location = useLocation();
  const { pathname } = location; // TODO: useParams
  const [course, setCourse] = useState({});
  const [lessons, setLessons] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(async () => {
    try {
      const { lesson_modules, lesson } = await fetchLessonModules(lessonId);
      setItems(lesson_modules);

      const res = await fetchCourse(lesson.course_id);
      setCourse(res)
    } catch (err) {
      console.log(err)
    }
  }, [pathname])
  
  useEffect(async () => {
    if (course.id) {
      try {
        const res = await fetchLessons(course.id)
        setLessons(res);
      } catch (err) {
        // TODO: handle error
        console.log(err)
      }
    }
  }, [course]);

  useEffect(() => {
    const arr = [];
    lessons.forEach(({
      id, // lessonId
      title,
    }) => {
      const path = `/lessons/${id}/preview`;
      arr.push({
        path: path,
        text: title,
        active: path === pathname,
      })
    })
    setItems(arr);
  }, [lessons]);
  
  return (
    <div className="TeacherReaderSidebar">
      <div className="EmployeeReaderItemsContainer">
        <div className="EmployeeReaderItemsHeaderContainer">
          <div className="EmployeeReaderItemsHeaderTab" />
          <div className="EmployeeReaderItemsHeader">All Lessons</div>
        </div>
        <TeacherReaderItems items={items} />
      </div>
    </div>
  )
}

export default TeacherReaderSidebar;
